export enum ERestorePasswordResult {    
    Failed,
    UserNotFound,
    Success
}